import React, {useEffect, useState} from 'react';
import {TextField, Box, InputAdornment} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {useSelector} from 'react-redux';
import {DateRangePicker} from 'rsuite';
import {useDispatch} from 'react-redux';
import Select from './Select';
import {getCustomers, getEntrances} from '../actions';

const Filters = ({
  withSearch,
  searchLabel = 'Search',
  searchValue,
  onSearchChange,
  withElevator,
  elevator,
  onChangeElevator,
  clearElevator,
  withBuilding,
  building,
  onChangeBuilding,
  clearBuilding,
  withEntrance,
  entrance,
  onChangeEntrance,
  clearEntrance,
  withCustomer,
  customer,
  onChangeCustomer,
  clearCustomer,
  withDateRange,
  dateRanges,
  onChangeDates,
  customerToShow,
  position = 'right',
  m = '0',
}) => {
  const dispatch = useDispatch();
  const {allElevators, allElevatorsLoading} = useSelector(s => s.elevators);
  const {entrances, entrancesLoading} = useSelector(s => s.entrances);
  const {customers, customersLoading} = useSelector(s => s.customers);
  const {allBuildings , allBuildingsLoading} = useSelector(s => s.buildings);

  const [inputValue, setInputValue] = useState('');

  // The entrance dropdown only offers entrances of the selected project (all of them when
  // no project is chosen). GET /entrance is paginated, so ask for a large page.
  useEffect(() => {
    if (!withEntrance) return;
    dispatch(getEntrances(building ? {buildingId: building, size: 1000} : {size: 1000}));
  }, [withEntrance, building, dispatch]);

  const onInputChange = (e, newInputValue) => {
    setInputValue(newInputValue);
    dispatch(getCustomers({q: newInputValue}));
  };

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent={position === 'right' ? 'flex-end' : 'flex-start'}
      alignItems="center"
      m={m}
      mb="1.5rem"
      gap="1rem"
      sx={{
        justifyContent: {
          xs: 'flex-start',
          sm: position === 'right' ? 'flex-end' : 'flex-start',
        },
        px: {xs: '1rem', sm: 0},
        '& > *': {maxWidth: '100%'},
      }}>
      {withSearch && (
        <TextField
          sx={{width: {xs: '100%', sm: 'auto'}}}
          label={searchLabel}
          placeholder={searchLabel}
          value={searchValue}
          onChange={onSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
      {withBuilding && (
        <Select
          items={allBuildings}
          value={building}
          onChangeValue={onChangeBuilding}
          label="Filter by project"
          disabled={allBuildingsLoading}
          onClear={clearBuilding}
          width={{xs: '100%', sm: '230px'}}
        />
      )}
      {withEntrance && (
        <Select
          items={entrances}
          value={entrance}
          onChangeValue={onChangeEntrance}
          label="Filter by entrance"
          disabled={entrancesLoading}
          onClear={clearEntrance}
          width={{xs: '100%', sm: '230px'}}
        />
      )}
      {withCustomer && (
        <Select
          items={customers}
          value={customerToShow}
          onChangeValue={onChangeCustomer}
          label="Filter by customer"
          disabled={customersLoading}
          onClear={clearCustomer}
          width={{xs: '100%', sm: '230px'}}
          withSearch
          inputValue={inputValue}
          getOptionLabel={option => `${option.firstName} ${option.lastName}`}
          onInputChange={onInputChange}
        />
      )}
      {withElevator && (
        <Select
          items={allElevators}
          value={elevator}
          onChangeValue={onChangeElevator}
          label="Filter by elevator"
          disabled={allElevatorsLoading}
          onClear={clearElevator}
          width={{xs: '100%', sm: '230px'}}
          isElevator
        />
      )}
      {withDateRange && (
        <Box sx={{width: {xs: '100%', sm: 'auto'}}}>
        <DateRangePicker
          block
          size="lg"
          showOneCalendar
          format="dd/MM/yyyy"
          placeholder="Filter by date"
          placement={position === 'right' ? 'bottomEnd' : 'bottomStart'}
          character=" - "
          value={dateRanges || null}
          onChange={onChangeDates}
        />
        </Box>
      )}
    </Box>
  );
};

export default Filters;
